import { useEffect, useMemo } from "react";
import { isEqual } from "lodash-es";
import { saveData } from "@aspen/libs";

/**
 * @description: 该方法用于在query hook中判断是否需要更新已缓存的数据。
 * @param {string} queryKey - queryKey
 * @param {any} freshData - query hook返回的数据
 * @param {any} cacheData - 缓存的数据
 * @param {boolean} isPlaceholderData - 是否是占位数据
 */
export const useUpdateQueryCache = (
  queryKey: string,
  freshData: any,
  cacheData: any,
  isPlaceholderData: boolean,
) => {

  const shouldUpdateStorage = useMemo(() => {
    return !isPlaceholderData && freshData && !isEqual(freshData, cacheData);
  }, [isPlaceholderData, freshData, cacheData]);

  useEffect(() => {
    if (shouldUpdateStorage) {
      saveData(queryKey, freshData);
    }
  }, [shouldUpdateStorage]);
};
